import { o_util } from "@gr-common/head/namespaces";
import { assignNamespace } from "@gr-common/head/namespace-utils";
import { runWithSpan, withSpan } from "./head/span";
import { initErrorHandling } from "./head/errors.js";

assignNamespace(o_util, "apm", { runWithSpan, withSpan });
initErrorHandling();

export { runWithSpan, withSpan };
